import type { AppNavItem } from '@fuze/portal-modules';

import { navCopy } from '@/content';

/** Open tasks (the Tasks nav item). */
export const TASKS_PATH = '/tasks';
/** All patients (the Patients nav item). */
export const PATIENTS_PATH = '/patients';
/** All prescribers (the Prescribers nav item). */
export const PRESCRIBERS_PATH = '/prescribers';
/** Forms and learning links (the Resources nav item). */
export const RESOURCES_PATH = '/resources';
/** The signed-in user's settings (the Settings nav item). */
export const SETTINGS_PATH = '/settings';

export const NAV_SECTIONS = [
  [{ href: '/', label: navCopy.overview, icon: 'home' }],
  [
    { href: TASKS_PATH, label: navCopy.tasks, icon: 'inbox' },
    { href: PATIENTS_PATH, label: navCopy.patients, icon: 'groups' },
    { href: PRESCRIBERS_PATH, label: navCopy.prescribers, icon: 'stethoscope' },
    { href: RESOURCES_PATH, label: navCopy.resources, icon: 'menu_book' },
    { href: SETTINGS_PATH, label: navCopy.settings, icon: 'settings' },
  ],
] as const satisfies readonly (readonly AppNavItem[])[];

/** Where New patient (on the dashboard) leads: patient enrollment, a placeholder until it's built. */
export const NEW_PATIENT_PATH = `${PATIENTS_PATH}/new`;

/**
 * One patient's page, a placeholder until it's built. React Router ranks the static `/patients/new` above this
 * dynamic route, so `new` always means enrollment; patient ids are opaque API ids, never the word "new".
 */
export const patientPath = (patientId: string) => `${PATIENTS_PATH}/${encodeURIComponent(patientId)}`;
/** The route pattern for patientPath. */
export const PATIENT_ROUTE = `${PATIENTS_PATH}/:patientId`;

/** One clinic's page (clinic details), a placeholder until it's built. */
export const clinicPath = (clinicId: string) => `/clinics/${encodeURIComponent(clinicId)}`;
/** The route pattern for clinicPath. */
export const CLINIC_ROUTE = '/clinics/:clinicId';

/** The prescriber's REMS enrollment, where the "Start REMS enrollment" task leads; a placeholder until it's built. */
export const REMS_ENROLLMENT_PATH = '/rems-enrollment';
